import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'
import { NonceProvider } from './utils/nonce-provider.ts'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

function getDocumentNonce() {
	const el = document.querySelector('script[nonce], style[nonce]')
	return el?.getAttribute('nonce') ?? ''
}

startTransition(() => {
	hydrateRoot(
		document,
		<NonceProvider value={getDocumentNonce()}>
			<HydratedRouter />
		</NonceProvider>,
	)
})
